var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_2290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1744 24.9242H4.39542C1.97036 24.9242 0 22.9538 0 20.5288V4.39542C0 1.97036 1.97036 0 4.39542 0H28.1744C30.5995 0 32.5699 1.97036 32.5699 4.39542V20.5119C32.5867 22.9538 30.5995 24.9242 28.1744 24.9242ZM4.39542 2.02088C3.08184 2.02088 2.02088 3.08184 2.02088 4.39542V20.5119C2.02088 21.8255 3.08184 22.8865 4.39542 22.8865H28.1744C29.488 22.8865 30.549 21.8255 30.549 20.5119V4.39542C30.549 3.08184 29.488 2.02088 28.1744 2.02088H4.39542Z",
    fill: "#6C6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2851 18.171L1.26318 2.72809L2.71148 1.31348L16.2851 15.2744L29.8586 1.31348L31.3069 2.72809L16.2851 18.171Z",
    fill: "#6C6A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_2290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.5867,
    height: 24.9242,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.476c7a2a4746391516778639b100d5f1.svg";
export { ForwardRef as ReactComponent };